import Session from "../utils/Session";
import Client from "./_client";

export const getFieldOptionById = async (fieldOptionId) => {
    const result = await new Client({
        path: `/fieldOption/${fieldOptionId}`,
    }).get();

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message || "Uh Oh! Unable to get field option. Please try again."
        );
    }

    return result.data;
};

export const saveFieldOption = async (
    fieldOptionId,
    fieldOptionData
) => {
    let result;

    if (fieldOptionId) {
        // Invoke API to update template
        result = await new Client({
            path: `/fieldOption/${fieldOptionId}`,
            payload: {
                field: fieldOptionData.field,
                option: fieldOptionData.option,
                user: fieldOptionData.user || process.env.REACT_APP_LANGUIFY_ADMIN_USER_ID,
            },
        }).put();
    } else {
        // Invoke API to create template
        result = await new Client({
            path: `/fieldOption`,
            payload: {
                field: fieldOptionData.field,
                option: fieldOptionData.option,
                user: fieldOptionData.user || process.env.REACT_APP_LANGUIFY_ADMIN_USER_ID,
            },
        }).post();
    }

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message ||
            "Uh Oh! Unable to save field option. Please try again."
        );
    }

    return result.data;
};

export const getFieldOptions = async (templateFilters = {}) => {
    let url = "/fieldOption?";

    if (!templateFilters.user) templateFilters.user = [
        process.env.REACT_APP_LANGUIFY_ADMIN_USER_ID,
        Session.userId
    ];

    Object.keys(templateFilters).forEach((key) => {
        if (templateFilters[key]) url += `${key}=${templateFilters[key]}&`;
    });

    const result = await new Client({
        path: url,
    }).get();

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message || "Uh Oh! Unable to get field options. Please try again."
        );
    }

    return result.data;
};

export const deleteFieldOptionById = async (fieldOptionId) => {
    const result = await new Client({
        path: `/fieldOption/${fieldOptionId}`,
    }).delete();

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message || "Uh Oh! Unable to delete field option. Please try again."
        );
    }

    return result?.data?.isDeleted;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getFieldOptionById,
    saveFieldOption,
    getFieldOptions,
    deleteFieldOptionById,
};
